"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInputContainerStyle = getInputContainerStyle;
exports.getInputStyle = getInputStyle;
exports.getRootStyle = getRootStyle;

var _utils = require("../utils");

const font = {
  fontSize: '1rem',
  lineHeight: '1'
};

function getRootStyle(styleArgs) {
  const {
    $theme: theme
  } = styleArgs;
  const radius = theme.sizing.scale100;
  const borderColor = (0, _utils.getBorderColor)(styleArgs);
  const borderStyle = 'solid';
  const borderWidth = '1px';
  return {
    borderTopColor: borderColor,
    borderRightColor: borderColor,
    borderBottomColor: borderColor,
    borderLeftColor: borderColor,
    borderTopStyle: borderStyle,
    borderRightStyle: borderStyle,
    borderBottomStyle: borderStyle,
    borderLeftStyle: borderStyle,
    borderTopWidth: borderWidth,
    borderRightWidth: borderWidth,
    borderBottomWidth: borderWidth,
    borderLeftWidth: borderWidth,
    borderTopLeftRadius: radius,
    borderTopRightRadius: radius,
    borderBottomRightRadius: radius,
    borderBottomLeftRadius: radius
  };
}

function getInputContainerStyle(styleArgs) {
  const {
    $disabled: disabled,
    $theme: theme
  } = styleArgs;
  return {
    backgroundColor: disabled ? theme.colors.grey10 : theme.colors.white
  };
}

function getInputStyle({
  $theme: theme
}) {
  return { ...font,
    color: theme.colors.grey70,
    // @ts-ignore
    '::placeholder': {
      color: theme.colors.grey50
    }
  };
}